export type SupportedImageTransformationsProvider =
  | "cloudflare-images"
  | "bunny"
  | "none";

export const TRANSFORMATION_MAP = {
  ogsource: "width=1200,height=630,fit=cover,format=jpeg,quality=75",
  ogsourceblurred: "width=1200,height=630,fit=cover,format=jpeg,quality=75,blur=80",
  ogpreview: "width=1200,fit=cover,format=webp,quality=80",
  large: "width=1920,format=webp,quality=85",
  largeblurred: "width=1920,format=webp,quality=85,blur=80",
  thumbnail: "width=400,fit=cover,format=webp,quality=75",
  thumbnailblurred: "width=400,fit=cover,format=webp,quality=75,blur=80",
  profile: "width=200,height=200,fit=cover,format=webp,quality=80",
  original: null,
} as const;

export type ImageTransformationKind = keyof typeof TRANSFORMATION_MAP;

export interface IImageTransformationsProvider {
  identifier: SupportedImageTransformationsProvider;

  buildImageCDNUrl(key: string, kind?: ImageTransformationKind): string;
  convertToTransformationUrl(
    current: string,
    kind?: ImageTransformationKind,
  ): string;
  isTransformationUrl(url: string): boolean;
}
